import { useCallback, useState, useContext } from 'react';
import { AppContext } from '../../providers/AppContext';
import {
  StyledVictoryCaptionEditor,
  StyledVictoryCaptionDecorator,
  StyledVictoryCaptionText,
  StyledEditControls,
  StyledLimit,
  StyledControl,
  StyledVictoryCaptionControls
} from './VictoryCaptionEditor.styled';
import { checkProfanity } from '../../utils';

const VictoryCaptionEditor = ({ initText = '', limit = 140, placeholder = 'Type your victory caption here', onSave = () => {} }) => {
  const [editMode, setEditMode] = useState(false);
  const [text, setText] = useState(initText.slice(0, limit));
  const { setErrorData } = useContext(AppContext);
  const setTextOnChange = useCallback((data) => {
    setText(data.slice(0, limit));
  }, [limit, setText]);

  const onConfirmText = () => {
    if (checkProfanity(text)) {
      setErrorData({ title: 'Error', description: 'Sorry, we do not accept obscenity!' });
      setText(initText);
    } else {
      setEditMode(false);
      onSave(text);
    }
  };

  const onReset = () => {
    setText(initText.slice(0, limit));
    setEditMode(false);
  };

  return (
    <StyledVictoryCaptionEditor>
      <StyledVictoryCaptionDecorator $focused={editMode}/>
      <StyledVictoryCaptionText
        disabled={!editMode}
        rows={2}
        placeholder={placeholder}
        value={text}
        onChange={(event) => setTextOnChange(event.target.value)}
      />
      {editMode ? (
        <StyledVictoryCaptionControls>
          <StyledLimit>{text.length}/{limit}</StyledLimit>
          <StyledEditControls>
            <StyledControl onClick={onReset}>
              <img src='/assets/close.svg' />
            </StyledControl>
            <StyledControl onClick={onConfirmText}>
              <img src='/assets/done_white.svg' />
            </StyledControl>
          </StyledEditControls>
        </StyledVictoryCaptionControls>
      ) : (
        <StyledVictoryCaptionControls>
          <div/>
          <StyledControl onClick={() => setEditMode(true)}>
            <img src='/assets/edit.svg'/>
          </StyledControl>
        </StyledVictoryCaptionControls>
      )}
    </StyledVictoryCaptionEditor>
  );
};

export default VictoryCaptionEditor;

